import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class AcademicLevelsService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) {}

  addAcademicLevel(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.academicLevel.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allAcademicLevels(pagination?: { page?: number; limit?: number }) {
    const params: any = {};
    
    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }
    
    return this.httpService.makeRequest({
      path: this.routes.academicLevel.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editAcademicLevel(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.academicLevel.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteAcademicLevel(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.academicLevel.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.academicLevel.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
